export default "__VITE_ASSET__CWiNKo2c__"